"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tf = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 600 400", ...props },
    react_1.default.createElement("defs", null,
        react_1.default.createElement("path", { id: "tf_svg__a", fill: "#fff", d: "M0-1 .588.809-.952-.309H.952L-.588.809z", transform: "scale(21)" })),
    react_1.default.createElement("path", { fill: "#002395", d: "M0 0h600v400H0z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "M0 0h244v164H0z" }),
    react_1.default.createElement("path", { fill: "#002395", d: "M0 0h80v160H0z" }),
    react_1.default.createElement("path", { fill: "#ED2939", d: "M160 0h80v160h-80z" }),
    react_1.default.createElement("path", { fill: "#fff", d: "m355 183 12.875 20.5H404.5V275L377 232l-37 59h18l19-34 39 70 39-70 19 34h18l-37-59-27.5 43v-39.5H444l12.25-19.5H427.5v-12.5h36.625L477 183H355zm43 87.5h-40v14h40zm76 0h-40v14h40z" }),
    react_1.default.createElement("use", { xlinkHref: "#tf_svg__a", x: 416, y: 362 }),
    react_1.default.createElement("use", { xlinkHref: "#tf_svg__a", x: 371, y: 328 }),
    react_1.default.createElement("use", { xlinkHref: "#tf_svg__a", x: 461, y: 328 }),
    react_1.default.createElement("use", { xlinkHref: "#tf_svg__a", x: 333, y: 227 }),
    react_1.default.createElement("use", { xlinkHref: "#tf_svg__a", x: 499, y: 227 })));
exports.default = Tf;
//# sourceMappingURL=Tf.js.map